import React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { getCustomFields } from "../../selectors";
import { getters } from "../../model";
import CollapsablePanel from "Portal/NewPortal/Shared/CollapsablePanel";
import { Div } from "components/Base";
import { Label } from "EventLight/Common/FieldLayout";

import useDisplay from "Portal/NewPortal/Shared/useDisplay";
import { resolveField } from "../EventInfo/EventInfo";

const decorate = R.compose(
  connect((state, props) => ({
    data: getters.data(state),
    lockedFieldIds: getters.lockedFieldIds(state),
    updatedFieldValues: getters.updatedFieldValues(state),
    fields: getCustomFields(state, props)
  }))
);

const CustomFields = ({
  fields,
  lockedFieldIds,
  data = {},
  updatedFieldValues = {}
}) => {
  const display = useDisplay();

  if (!fields.length) {
    return null;
  }

  return (
    <Div display="column">
      <CollapsablePanel title="Additional Information">
        <Div display="column" p={5} style={{ gap: 16 }} width={1}>
          {fields.map(pairedFields => {
            return (
              <Div
                display={display}
                width={1}
                style={{
                  gap: 20
                }}
              >
                {pairedFields.map(field => {
                  return (
                    <Div display="column" width={1}>
                      <Label fs={2} color="neutral7">
                        {field.name}
                      </Label>
                      {resolveField({
                        field,
                        data,
                        updatedFieldValues,
                        disabled: lockedFieldIds.includes(field.id)
                      })}
                    </Div>
                  );
                })}
              </Div>
            );
          })}
        </Div>
      </CollapsablePanel>
    </Div>
  );
};

export default decorate(CustomFields);
